import { useState, useRef, useEffect } from 'react'
import {
  PlayCircle,
  Music3,
  Camera,
  Bird,
  UserSquare,
  Plus,
} from 'lucide-react'
import { INSERT_SOCIAL_EMBED_COMMAND, PROVIDERS } from '../nodes/EmbedNode'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'

/* מזהה ספק ע"פ קישור או בחירה ידנית */
function detectProvider(raw, explicit) {
  if (explicit) return explicit
  const found = Object.entries(PROVIDERS).find(([, { re }]) => re.test(raw))
  return found?.[0] ?? null
}

export function InsertMenu() {
  const [editor] = useLexicalComposerContext()
  const [open, setOpen] = useState(false)
  const boxRef = useRef(null)

  const promptAndInsert = (explicitProvider) => {
    const raw = prompt('הדבק קישור מלא או מזהה סרטון / פוסט')
    if (!raw) return
    const provider = detectProvider(raw.trim(), explicitProvider)
    if (!provider || !PROVIDERS[provider])
      return alert('קישור או פלטפורמה לא נתמכים 😕')

    const { re, toSrc } = PROVIDERS[provider]
    const idOrUrl = re ? raw.match(re)?.[1] || raw : raw
    editor.dispatchCommand(INSERT_SOCIAL_EMBED_COMMAND, {
      provider,
      src: toSrc(idOrUrl),
    })
    setOpen(false)
  }

  /* סגירת התפריט בלחיצה-חוץ */
  useEffect(() => {
    const handler = (e) =>
      boxRef.current && !boxRef.current.contains(e.target) && setOpen(false)
    window.addEventListener('mousedown', handler)
    return () => window.removeEventListener('mousedown', handler)
  }, [])

  return (
    <div ref={boxRef} className="relative">
      <button
        type="button"
        className="btn flex gap-1 text-white"
        onClick={() => setOpen((o) => !o)}
      >
        <Plus size={16} /> Insert
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-44 rounded-md bg-zinc-800 p-2 shadow-lg flex flex-col gap-1">
          <button
            type="button"
            className="menu-item"
            onClick={() => promptAndInsert('youtube')}
          >
            <PlayCircle size={16} /> YouTube
          </button>
          <button
            type="button"
            className="menu-item"
            onClick={() => promptAndInsert('tiktok')}
          >
            <Music3 size={16} /> TikTok
          </button>
          <button
            type="button"
            className="menu-item"
            onClick={() => promptAndInsert('instagram')}
          >
            <Camera size={16} /> Instagram
          </button>
          <button
            type="button"
            className="menu-item"
            onClick={() => promptAndInsert('twitter')}
          >
            <Bird size={16} /> X
          </button>
          <button
            type="button"
            className="menu-item"
            onClick={() => promptAndInsert('facebook')}
          >
            <UserSquare size={16} /> Facebook
          </button>
        </div>
      )}
    </div>
  )
}
